import Vue from 'vue';
import Component from 'vue-class-component';
import {Viewport} from '../models/Viewport';
import {Language} from '../models/ProductModels';
import VueI18n from 'vue-i18n';


@Component({
 props:{
 }
})
export default class SoftbookLangDropdown extends Vue {
    languageString:string;


    onChange(event:Event){
       // console.log('THE LOCALE IS ,',this.$i18n.locale)
        this.$route.params.locale = this.$i18n.locale;
        this.$router.push(`/${this.$i18n.locale}`);
       // console.log("ROUTER LOCALE IS: ", this.$route.params);
    }

    created(){
      //  console.log('THE LOCALE In Dropdown ist ,',this.$i18n.locale)

    }
}